import api, { STUDENT_MEDIA_URL, STUDENT_URL } from "./api";

export const fetchStudentcheduledMeetings = async (
  studentId,
  startDate,
  endDate
) => {
  return await api.get(
    `${STUDENT_URL}/${studentId}/meetings/from/${startDate}/to/${endDate}`
  );
};

export const fetchStudentOffers = async (studentId) => {
  return await api.get(`${STUDENT_URL}/${studentId}/offers`);
};

export const uploadStudentMedia = async (studentId, body) => {
  return await api.post(`${STUDENT_URL}/${studentId}/media`, body);
};

export const deleteStudentMedia = async (studentMediaId) => {
  return await api.delete(`${STUDENT_MEDIA_URL}/${studentMediaId}`);
};

export const fetchStudentMedia = async (studentId, body) => {
  return await api.post(`${STUDENT_URL}/${studentId}/getMedia`, body);
};

export const fetchStudentProfileDetail = async (studentId) => {
  return await api.get(`${STUDENT_URL}/${studentId}`);
};

export const fetchStudentNotifications = async (studentId) => {
  return await api.get(`${STUDENT_URL}/${studentId}/warnings`);
};

export const studentSubmit = async (studentId, body) => {
  return await api.put(`${STUDENT_URL}/${studentId}`, body);
};


